<template>
  <header class="landing-page-header">
    <div class="header-container">
      <div class="header-logo">
        <img :src="require('@/common/assets/icons/akkodis-brand-logo.svg')" alt="Akkodis">
      </div>
      <div class="language-container">
        <ApplicationLanguageControl :container-classes="['dark-mode']"/>
      </div>
    </div>
  </header>
</template>

<script>
import ApplicationLanguageControl from "@/common/components/ApplicationLanguageControl.vue";

export default {
  name: "LandingHeader",
  components: {ApplicationLanguageControl}
}
</script>

<style lang="scss">
.landing-page-header {
	width: 100%;

  .language-option {
    height: 3vh;
    display: flex;
    align-items: center;
    padding: 0.5vh 0.8vw !important;
    img {
      height: 1.5vh;
      width: auto;
      max-width: none !important;

      &.flag {
        margin-right: 0.5vw !important;
      }

      &.arrow {
        margin: 0 !important;
        padding: 0 !important;
        height: 1.8vh !important;
        margin-left: 0.2vw !important;
      }
    }

    span {
      font-size: 1.7vh !important;
      line-height: normal !important;
    }
  }
}

</style>
<style scoped lang="scss">
header {
  padding: 2vh 3vw;
  height: 8vh;
  position: absolute;
  background: none;
  box-shadow: none;

  .header-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .language-container {
    line-height: 0px;
  }

  .header-logo {
    cursor: default;
    line-height: 0;

    img {
      width: auto;
      height: 2vh;
      margin: 0.5vh;
    }
  }

  .language-option {
    height: 3vh;
  }
}

</style>
